import React, { Component } from "react";
import styles from "./index.less";

interface Props {
  path: string;
  tip: string;
  punishRecordTips?: any;
}

class Prompt extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { path, tip, punishRecordTips } = this.props;
    return (
      <div className={styles.prompt}>
        <img src={path} />
        {punishRecordTips ? (
          <div className={styles.tip}>
            {punishRecordTips.text.slice(0, punishRecordTips.start)}
            <span
              onClick={() => {
                window.open(punishRecordTips.url);
              }}
            >
              {punishRecordTips.text.slice(
                punishRecordTips.start,
                punishRecordTips.end
              )}
            </span>
            {punishRecordTips.text.slice(punishRecordTips.end)}
          </div>
        ) : (
          <div className={styles.tip}>{tip}</div>
        )}
      </div>
    );
  }
}

export default Prompt;
